import { LanguageService } from './language.service';
import { TranslateService } from '@ngx-translate/core';
import { RouteDataService } from './route-data.service';
import { Meta, Title } from '@angular/platform-browser';
import { effect, inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SeoService {
  private meta = inject(Meta);
  private titleService = inject(Title);
  private routeDataService = inject(RouteDataService);
  private translate = inject(TranslateService);
  private languageService = inject(LanguageService);

  constructor() {
    effect(() => {
      this.updateTitle();
    });
  }

  // nnkitodo [v2later router] nettoyer + renommer tout student + public area
  // nnkitodo [v2later router] ajouter dans le title 'dashboard' si on est dans la writer area / idem student / public
  // nnkitodo [v2later] utiliser breadcrumb:label partout au lieu de navbarTitleKey
  init() {
    this.meta.updateTag({
      name: 'description',
      content: $localize`:@@meta.description:Notre logiciel d'ancrage des connaissances® utilise un algorithme développé par nos ingénieurs pour faire travailler ta mémoire à long terme. L'utilisation de la répétition espacée permet d'assurer un apprentissage efficace, pour ne rien oublier le jour J.`,
    });
  }

  private updateTitle() {
    const nodeData = this.routeDataService.lastRouteData();

    let title = $localize`Le site de préparation aux EDN`;
    if (nodeData?.breadcrumb?.label) title = nodeData?.breadcrumb?.label;
    else if (nodeData?.navbarTitleKey)
      title = this.translate.instant(
        nodeData.navbarTitleKey,
        nodeData.navbarTitleMetadata ? nodeData.navbarTitleMetadata : {}
      );

    this.titleService.setTitle(`${this.languageService.siteName} | ${title}`);
  }
}
